import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";

import back from "../../back.png";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputChecbox from "../../helpers/InputCheckbox";
import InputCombo from "../../helpers/InputCombo";
import InputEmail from "../../helpers/InputEmail";
import InputPhone from "../../helpers/InputPhone";
import InputInteger from "../../helpers/InputInteger";
import InputSearchClient from "../../helpers/InputSearchClient";
import InputDate from "../../helpers/InputDate";
import InputTextArea from "../../helpers/InputTextArea";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputComboWaluty from "../../helpers/InputComboWaluty";




function ContractForm(props)
{

      const [checked1, setChecked1] = useState(false);
      const handleChange1= () => {
          setChecked1(!checked1);
      };  


    const [errTab, setErrTab] = useState([]); 


    var defId = -1;
    if(props.fak_kontrahenci_id != undefined) defId = props.fak_kontrahenci_id;

    const [row, setRow] = useState({


        id: '-1',

        fak_kontrahenci_id: defId,    
        data_zawarcia: '',    

        ilosc_darmowych_miesiecy: '0',    
        okres_umowy_m: '-1',    
        dokladna_data_zakonczenia: '',    

        informacje_dodatkowe: '',   
        
        stan_umowy: 1, 

        sl_stany_umow_id: -1, 
        wg_inflacji: '0', 
        inflacja_typ: 'GUS - wskaźnik cen', 



        bank: 0, 
        sl_rachunki_bankowe_id: '_x_',        

        e_faktura: 0,
        e_mail_dla_faktur: '',
        termin_platnosci: 14,
        blokada_za_brak_platnosci_w_terminie: '1',
        sl_waluty_id: '2',

    });
    var tmpRow = row;

    

    const [client,setClient] = useState(null);



    
    const valChangeListener = (filedName, val, correct, msg) => {   
        

           
              
        
               // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 2)
                {
                    var tabName = tabCheck[0];
                    var tabInx  = tabCheck[1];
                    var tRef = row[tabName];
                    if(correct)tRef[tabInx] = val;
                    if(!correct)tRef[tabInx] = "";

                    tmpRow[tabName] = tRef;     
                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
        
                    //setRowX( {...row, [tabName]:tRef } );   
                    if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;         


               

                setRow(  JSON.parse(JSON.stringify(tmpRow)) );    
            
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                          

                if(filedName == "fak_kontrahenci_id"  )
                {
                    var idF = -1;
     

                    if(val != null && val != undefined && val != -1)
                    {
                       var spx = val.split(' | ');
                       if(spx.length > 1)
                       {
                        idF = parseInt(spx[0]);
                       }
                    }

                    console.log("IDF " + idF);

                    if(idF != -1 )
                    {
                        getClientDet(idF);                            
                    }
                   

                   
                }

            }   
        
        
    const goNextNew = () => {
                console.log("goNext");               
            }



   const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                if(Config.env == 'dev') console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }

    
    const saveData = () => {
        

        if(!valChecker(row))
        {
                props.mainView.showDialog("Ups!" , "Wypełnij prawidłowo pola formularza"  ,  "error"  ,null); 
                
                return;
        }

        props.mainView.showProgress();
         

        fetch( Config.url + '/rest_v1_home,contract_set', {
            method: 'POST', 
            body: JSON.stringify(row), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

             
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                         if(props.onSuccess != undefined) props.onSuccess(res.result);    

                            props.mainView.showDialog( "Sukces",  "Dane zostały zapisane.", "ok" , (pp)=>{                                     
                                if(props.onAdded != undefined)  props.onAdded(res.result);   
                         } );                                                  
                                                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }





    const getClientDet = (idF) => {
        

        props.mainView.showProgress();
         

        fetch( Config.url + '/rest_v1_home,client_det', {
            method: 'POST', 
            body: JSON.stringify( { id: idF}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                
                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setClient(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }



    const getContractDet = (idF) => {
        

        props.mainView.showProgress();
      

        fetch( Config.url + '/rest_v1_home,contract_det', {
            method: 'POST', 
            body: JSON.stringify( { id: props.id}), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.hideProgress();

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setRow(res.result);                                                 
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                    props.mainView.hideProgress();
         });
                   

         return false;
    }


 
    const keyListener = (e) => {

                       var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                        }else
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {                                         
                        }else  
                        if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                        {
                                props.onBack();                               
                        } else
                        if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       saveData();
                                       e.preventDefault();
                                } else 
                        {
                            props.keyListener(e);
                        }


    }


     useEffect(() => {
        
                if(props.id > 0 && row.id == -1)
                {
                    getContractDet();
                }

                if(props.fak_kontrahenci_id != undefined && props.fak_kontrahenci_id > 0 && client == null )
                {
                    getClientDet(props.fak_kontrahenci_id);
                }              


                if(Config.env == "dev") console.log("ContractForm.js, listener on");
                window.onkeydown = keyListener;

                return () => {          
                    if(Config.env == "dev") console.log("ContractForm.js, listener off");      
                    window.onkeydown = props.keyListener;
                };

      });
   


      


    return  <div className="view_content">

      
 
                <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>   

               

                            {
                                row.numer_umowy != undefined &&
                                <Fragment>
                                    <h3 className="dash_header">{row.klient.nazwa} 
                                         / Umowy / 
                                         &nbsp;{row.numer_umowy}
                                    </h3>
                                </Fragment>
                            }
                             

                <form className="eForm bg_center">

                    

                 {
                    row.stan_umowy != '1' && 
                     <div className="client_info  waiting  ">
                       Umowa zakończona lub oczekuje na zatwierdzenie.
                     </div>
                 } 

                 {
                    row.stan_umowy == '1' && 
                     <div className="client_info  approved  ">
                       Umowa aktywna 
                     </div>
                 }   

                         
                            <div className="form_tab_title">Dane umowy:</div>
                            
                            <div className="form_tab">
                                {    
                                    props.fak_kontrahenci_id < 1 &&                             
                                
                                    
                                                <div className="form_control">
                                                    <div className="fieldName">Nazwa klienta lub NIP*</div>
                                                    <InputSearchClient   userData={props.userData}  mainView={props.mainView} value={row.fak_kontrahenci_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="fak_kontrahenci_id" placeholder={"Klient:"} className=' w300 ' req='1' firstUp="0" />
                                                </div>
                                
                                } 

                                <div className="form_control">
                                                    <div className="fieldName">Status umowy*</div>
                                                    <InputCombo  items={ [ {v:0, title:'Oczekuje na zatwierdzenie'} , {v:1, title:'Aktywna'} , {v:2, title:'Nieaktywna'}   ] }  userData={props.userData} value={row.stan_umowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="stan_umowy" placeholder={""} className=' ' req='1' firstUp="1" />
                                </div>

                            </div>
                                                     


                            {                               
                                <Fragment>


                                <div className="form_tab">

                                             
                                            <div className="form_control">
                                                <div className="fieldName">Data zawarcia*</div>
                                                <InputDate   userData={props.userData} value={row.data_zawarcia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_zawarcia" placeholder={"Data zawarcia"} className=' ' req='1' firstUp="1" />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">Czas trwania*</div>
                                                <InputCombo  items={ [ {v:-2, title:'Do dnia: '} , {v:-1, title:'Czas nieokreślony: '}, {v:12, title:'12 Miesięcy'}, {v:24, title:'24 Miesiące'}   ] }  userData={props.userData} value={row.okres_umowy_m} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="okres_umowy_m" placeholder={"Okres umowy"} className=' ' req='1' firstUp="1" />
                                            </div>


                                            {
                                                row.okres_umowy_m == -2 &&
                                                <div className="form_control">
                                                    <div className="fieldName">Data końca umowy*</div>
                                                    <InputDate   userData={props.userData} value={row.dokladna_data_zakonczenia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dokladna_data_zakonczenia" placeholder={"Data końca umowy"} className=' ' req='1' firstUp="1" />
                                                </div>

                                            }


                                            <div className="form_control">
                                                <div className="fieldName">Ilość darmowych miesięcy*</div>
                                                <InputInteger   userData={props.userData} value={row.ilosc_darmowych_miesiecy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ilosc_darmowych_miesiecy" placeholder={"Ilość darmowych miesięcy:"} className=' ' req='1' firstUp="1" />
                                            </div>



                                            <div className="form_split"></div>

                                            {
                                                client != null && client.bank != undefined && 
                                                <div className="bold_green">
                                                  Domyśle ustawienia klienta:  {client.bank.nazwa_banku} {client.bank.numer_rachunku}
                                                </div>
                                            }                                             

                                             <div className="form_control">
                                                <div className="fieldName">Numer rach. do wpłat*</div>
                                                 <InputCombo  items={ [ {v:0, title:'Domyślny, wg. ustawień klienta'} , {v:1, title:'Ustaw inny:'}   ] }  userData={props.userData} value={row.bank} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="bank" placeholder={""} className=' ' req='1' firstUp="1" />
                                            </div>

                                            {
                                                row.bank == 1 && 
                                                <div className="form_control">
                                                    <div className="fieldName">Numer rachunku do wpłat*</div>
                                                    <InputComboSubkonto  mainView={props.mainView} userData={props.userData} value={row.sl_rachunki_bankowe_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sl_rachunki_bankowe_id" placeholder={""} className=' ' req='1' firstUp="1" />
                                                </div>
                                            }
                                                                                        


                                            <div className="form_split"></div>
                                          

                                            <div className="form_control">
                                                <div className="fieldName">Termin płatności (ilość dni)*</div>
                                                <InputInteger   userData={props.userData} value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="termin_platnosci" placeholder={"Termin płatności:"} className=' ' req='1' firstUp="1" />
                                            </div>


                                            
                                            <div className="form_control">
                                                <div className="fieldName">Blokada za brak płatności*</div>
                                                 <InputCombo  items={ [ {v:0, title:'Nie'} , {v:1, title:'Tak'}   ] }  userData={props.userData} value={row.blokada_za_brak_platnosci_w_terminie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="blokada_za_brak_platnosci_w_terminie" placeholder={""} className=' ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Waluta*</div>
                                                <InputComboWaluty  mainView={props.mainView} userData={props.userData} value={row.sl_waluty_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="sl_waluty_id" placeholder={""} className=' ' req='1' firstUp="1" />
                                            </div>


                                        </div>     
                                        <div className="form_tab">

                                            {
                                                client != null && client.e_faktura == 0 &&
                                                <div className="bold_green">
                                                   Domyśle ustawienia klienta: brak e-faktury
                                                </div>
                                            }

                                             {
                                                client != null && client.e_faktura == 1 &&
                                                <div className="bold_green">
                                                  Domyśle ustawienia klienta:: e-faktura na adres: {client.e_mail_dla_faktur}
                                                </div>
                                            }


                                            <div className="form_control">
                                                <div className="fieldName">E-Faktura*</div>
                                                <InputCombo  items={ [ {v:0, title:'Domyślne ustawienia klienta'} , {v:1, title:'Tak, użyj adresu:'}   ] }  userData={props.userData} value={row.e_faktura} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="e_faktura" placeholder={""} className=' ' req='1' firstUp="1" />
                                            </div>

                                            {
                                                row.e_faktura == 1 &&
                                                <div className="form_control">
                                                    <div className="fieldName">Adres e-mail*</div>
                                                    <InputEmail   value={row.e_mail_dla_faktur} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="e_mail_dla_faktur" placeholder={""} className=' ' req={row.e_faktura} firstUp="1" />
                                                </div> 
                                            }



                                     
                                            </div>

                                            <div className="form_tab">

                                                <div className="form_control">
                                                    <div className="fieldName">Zapis o inflacji*</div>
                                                    <InputCombo  items={ [ {v:0, title:'Nie'} , {v:1, title:'Tak'}   ] }  userData={props.userData} value={row.wg_inflacji} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wg_inflacji" placeholder={""} className=' ' req='1' firstUp="1" />
                                                </div>


                                                 {
                                                    row.wg_inflacji == 1 &&
                                                    <div className="form_control">
                                                        <div className="fieldName">Rodzaj naliczania procentu inflacji*</div>
                                                        <InputCombo  items={ [ {v:'GUS - wskaźnik cen', title:'Wskaźnik cen'} , {v:'GUS - wzrost wynagrodzenia', title:'GUS - wzrost wynagrodzenia'}   ] }  userData={props.userData} value={row.inflacja_typ} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="inflacja_typ" placeholder={""} className=' ' req='1' firstUp="1" />
                                                    </div>
                                                 }   


                                            </div>



                                            <div className="form_tab_title">
                                                Informacje dodatkowe:
                                                            &nbsp; 
                                                            <label className="switch" title="Więcej">                               
                                                                <input type="checkbox" checked={checked1}  onChange={handleChange1}/>
                                                                <span className="slider round"></span>
                                                            </label>  

                                            </div>
                                            {
                                                checked1 == 1 &&
                                                <div className="form_tab">
                                                
                                                    <div className="form_control form_inline">
                                                                <div className="fieldName">Info*</div>
                                                                <InputTextArea  value={row.informacje_dodatkowe} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="informacje_dodatkowe" placeholder={""} className=' p100 h100 ' req='1' firstUp="1" />
                                                    </div>

                                                </div>
                                            }                           



                                            
                                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                        
                                                        <div className="btn" onClick={saveData}>zapisz zmiany [cntr+s]</div>
                                                        &nbsp;&nbsp;
                                                        <div className="btn" onClick={props.onBack}    > anuluj [back]</div>
                                            </div>


                                </Fragment>

                            }


                         





                </form>


        </div>

}


export default ContractForm;